import './index.scss'
$("header .nav li").eq(2).addClass("active");